import type { RuntimeConfig } from "nuxt/schema";

// composables/useBazaarvoice.js
export const useBazaarvoice = () => {
  const { $bv } = useNuxtApp();

  const formatToolstationOrder = (orderStore: any,runtimeConfig: RuntimeConfig) => {
    const productItems = orderStore.products.filter(
      (item) => !item.product.code.startsWith("0") && item.product.sellable
    );

    return {
      currency: "EUR",
      orderId: orderStore.order_id,
      total: orderStore.order.data.order_totals.raw.toString(),
      items: productItems.map((item) => ({
        productId: item.product.code,
        price: item.prices.product_raw.toString(),
        quantity: item.item_quantity,
        name: item.product.name,
        imageUrl: item.product.image,
        category: item.product.sub_department_id.toString(),
      })),
      orderDate: orderStore.order.data.order_date,
      customerFirstName: orderStore.order.data.customer_first_name,
      customerLastName: orderStore.order.data.customer_last_name,
      customerZip: orderStore.delivery_address.postcode,
      customerCountry: runtimeConfig.public.appRegion
    };
  };

  const trackPurchase = (orderStore: any,runtimeConfig:RuntimeConfig) => {
    const transactionData = formatToolstationOrder(orderStore,runtimeConfig);
    $bv.trackTransaction(transactionData);
  };

  // New methods for general tracking
  const trackPage = () => {
    $bv.trackPageView();
  };

  const trackCustomEvent = (eventName, data = {}) => {
    $bv.trackEvent(eventName, data);
  };

  return {
    trackPurchase,
    trackPage,
    trackCustomEvent,
  };
};
